import { z } from 'zod';
/**
 * Stable, machine-readable error codes. The frontend maps a code to a
 * translated message; it never parses the human-readable `message`.
 * Add codes, never repurpose them.
 */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UNIQUE_VIOLATION',
    'FOREIGN_KEY_VIOLATION',
    'RATE_LIMITED',
    'IDEMPOTENCY_KEY_REUSED',
    'PAYLOAD_TOO_LARGE',
    'UNPROCESSABLE',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    'NO_PLATFORM_ACCESS',
    'UA_UNAVAILABLE',
    'USERNAME_TAKEN',
    'USER_ALREADY_EXISTS',
    // Currency domain (currency.md).
    'CURRENCY_NOT_FOUND',
    'CURRENCY_LOCKED',
    'VIP_NOT_ENABLED',
    'VIP_NOT_PERMITTED',
    'INSUFFICIENT_BALANCE',
    'HOLDER_NOT_FOUND',
    'HOLDER_ROUTE_NOT_ALLOWED',
    'ALREADY_REVERSED',
    'EXCHANGE_NOT_FOUND',
    'NOTES_REQUIRED',
    'BOX_NOT_EMPTY',
    'CASHIER_NEEDS_ONE_BRANCH',
    // Boxes created in the dashboard with several employees (KAN-55, KAN-56).
    'BOX_NAME_TAKEN',
    'EMPLOYEE_NOT_ELIGIBLE',
    // Employees in several boxes and box status (decision 18).
    'BOX_UNAVAILABLE',
    'BOX_HAS_BALANCE',
    'SOLE_BOX_EMPLOYEE',
    'BOX_HAS_NO_EMPLOYEE',
    // Exchange app (currency.md sections 3.1 and 4.1).
    'SAME_CURRENCY',
    'IMAGE_INVALID',
    'IMAGE_NOT_FOUND',
    'EXCHANGE_APP_NOT_CONFIGURED',
    // Customer signature on the shared tablet (currency.md section 3.1.1).
    'TABLET_NOT_CONFIGURED',
    'TABLET_UNAVAILABLE',
    'TABLET_NOT_AVAILABLE',
    'TABLET_BUSY',
    'TABLET_REQUEST_NOT_FOUND',
    'TABLET_REQUEST_INVALID',
    'SIGNATURE_NOT_SAVED',
    // The phone rule (customers.md section 9.3).
    'PHONE_REQUIRED',
    'PHONE_INVALID',
    'PHONE_NOT_MOBILE',
    'PHONE_COUNTRY_NOT_ALLOWED',
    // WhatsApp phone verification (customers.md section 10, currency.md section 3.1).
    'PHONE_VERIFICATION_REQUIRED',
    'PHONE_VERIFICATION_NOT_ALLOWED',
    'PHONE_VERIFICATION_INVALID',
    'PHONE_VERIFICATION_RECEIPT_EXPIRED',
    'OTP_INVALID',
    'OTP_EXPIRED',
    'OTP_ATTEMPTS_EXCEEDED',
    'OTP_RESEND_TOO_SOON',
    'OTP_SEND_LIMIT',
    'OTP_SEND_FAILED',
    'OTP_ALREADY_VERIFIED',
    'OTP_ALREADY_CONSUMED',
    'OTP_BINDING_MISMATCH',
    'OTP_NOT_VERIFIED',
    'OTP_CONSUME_WINDOW_PASSED',
    'CUSTOMERS_UNAVAILABLE',
    'IDEMPOTENCY_CONFLICT',
    'REQUEST_IN_PROGRESS',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const fieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=api-error.js.map